import { Category, GenericObject, LocalizedString, copyFields } from '@synergy/models';

import { Price } from './price';
import { Supplier } from './supplier';

export class Product {
    public id!: number;
    public name!: LocalizedString;
    public orderUnitId?: number;
    public orderUnitName?: LocalizedString;
    public number?: string;
    public isActive!: boolean;
    public isNorm!: boolean;
    public isBestPrice!: boolean;
    public tax!: { [index: string]: number };

    public supplier!: Supplier;

    public categories?: Category[];
    public mainPrice!: { [index: string]: number };
    public prices!: Price[];

    public static fromPlainObject(object: GenericObject): Product {
        const product = new Product();

        copyFields(object, product);

        if (object['supplierAccount']) {
            product.supplier = Supplier.fromPlainObject(object['supplierAccount']);
        }

        if (object['prices']) {
            product.prices = object['prices'].map(Price.fromPlainObject);
        }

        if (object['categories']) {
            product.categories = object['categories'].map(Category.fromPlainObject);
        }

        return product;
    }
}
